import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * æ½è±¡å®ä½, ååç«¯ä¿æä¸è´
 */
@JsonObject
export abstract class AbstractEntity {
  /**
   * å®ä½id
   */
  @JsonProperty('id', Number, true)
  id: number = undefined;

  /**
   * åå»ºæ¶é´, æ¶é´æ³
   */
  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  /**
   * æåä¿®æ¹æ¶é´, æ¶é´æ³
   */
  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  /**
   * åå§å
   */
  init() {
    this.id = 0;
    this.createTime = 0;
    this.lastModified = 0;
  }
}
